import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo, useMemo, } from 'react';
import { optionTypes, selectionTypes, } from './constants';
import { defaultContext, PickerContext, } from './PickerContext';
export const defaultProps = Object.assign(Object.assign({}, defaultContext), { name: '', value: '' });
const Picker = ({ children, isLoading, modifier = defaultProps.modifier, name = defaultProps.name, onChange = defaultProps.onChange, selectionType, value = defaultProps.value, }) => {
    const roleType = useMemo(() => (selectionType === selectionTypes.multiple
        ? 'group'
        : 'radiogroup'), [
        selectionType,
    ]);
    const providerValue = useMemo(() => ({
        isLoading,
        modifier,
        name,
        onChange,
        optionType: optionTypes[selectionType],
        selectedOptions: value,
    }), [
        isLoading,
        modifier,
        name,
        onChange,
        selectionType,
        value,
    ]);
    return (_jsx("div", Object.assign({ id: name, role: roleType }, { children: _jsx(PickerContext.Provider, Object.assign({ value: providerValue }, { children: children })) })));
};
const MemoizedPicker = memo(Picker);
export { MemoizedPicker as Picker };
// MC-1068 Temporary hack for Storybook.
export default Picker;
